export const constant = {
    PROMPT: "Your account is currently unverified"
}